import { render, staticRenderFns } from "./Titulo.vue?vue&type=template&id=43cf21dd"
import script from "./Titulo.vue?vue&type=script&lang=js"
export * from "./Titulo.vue?vue&type=script&lang=js"
import style0 from "./Titulo.vue?vue&type=style&index=0&id=43cf21dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports